import { BaseUrlData } from 'actions/system/createBaseUrlAction'
import { photoViewerBasePath } from 'components/page/PhotoViewer/PhotoViewer.paths'
import { mergeAllUrls } from 'functions/mergeAllUrls'

/**
 *
 * @param {string} path
 * @param {BaseUrlData} layoutContext
 */
export const createPhotoViewerUrl = (
  path: string | undefined,
  layoutContext: BaseUrlData
): string => {
  const { baseUrl } = layoutContext

  return mergeAllUrls(baseUrl, photoViewerBasePath, path!)
}
